var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('top',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showHeader),expression:"$route.meta.showHeader"}],attrs:{"showTopNav":_vm.$route.meta.showTopNav}}),_vm._v(" "),_c('keep-alive',{attrs:{"include":[
			'home',
			'live',
			'Jengabet',
			'boosted-multibet',
			'casino',
			'casino-category',
			'my-bets' ]}},[_c('router-view')],1),_vm._v(" "),_c('bottom',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showFooter),expression:"$route.meta.showFooter"}]}),_vm._v(" "),(
			!_vm.env.disabledFeatures.includes('accaBonus') &&
				['home', 'prebets-markets', 'live', 'live-markets'].includes(
					_vm.$route.name
				)
		)?_c('acca-on-mini-betslip'):_vm._e(),_vm._v(" "),(_vm.showMiniBetslip)?_c('mini-betslip'):_vm._e(),_vm._v(" "),_c('data-notifier')],1)}
var staticRenderFns = []

export { render, staticRenderFns }